import { get } from 'api/api';

export default () => get('/rainmakers_admins?recruiter=true&include_set=user');
